import React from "react";

const Nodata = ({ nodataLabel, nodataDesc, buttonLabel }) => {
  return (
    <div className="flex flex-col items-center justify-center w-full max-w-md p-6 mx-auto">
      <img src="/noData.png" alt="" />
      <h2 className="text-xl font-semibold text-gray-900 capitalize">
        {nodataLabel || "Data Not Found"}
      </h2>
      {nodataDesc && <p>{nodataDesc}</p>}
    </div>
  );
};

export default Nodata;
